(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["vue"], factory);
	else if(typeof exports === 'object')
		exports["TimerCountdown"] = factory(require("vue"));
	else
		root["PolyvILScene"] = root["PolyvILScene"] || {}, root["PolyvILScene"]["TimerCountdown"] = factory(root["Vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__8__) {
return 